export default "__VITE_ASSET__B1agv7Yq__"